<template>
  <div class="d-flex justify-content-between align-items-center parent-controls flex-wrap">
    <challenge-stars-info
      :stars-to-win="getPossibleStarsToday"
      :stars-earned="starsEarnedByChild"
      :current-child="currentChild"
      class="mb-2 mb-sm-none"
    />
    <div
      class="challenge-buttons-groups d-flex flex-column flex-sm-row justify-content-end align-items-stretch"
    >
      <custom-button @click="openModal">
        + Create Goal
      </custom-button>
      <custom-button
        router
        :to="{ name: 'PlanDescription', params: { Mid: homeChallengeSkillId } }"
      >
        Tips for Set Up
      </custom-button>
      <custom-button router :to="{ name: 'Progress', query: { showChild: true } }">
        Check Progress
      </custom-button>
    </div>
    <challenge-parent-goal-modal ref="newModal" :child="currentChild" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import CustomButton from '@/components/general/CustomButton.vue';
import ChallengeParentGoalModal from './modals/ChallengeParentGoalModal.vue';
import ChallengeStarsInfo from './ChallengeStarsInfo.vue';

export default {
  components: {
    CustomButton,
    ChallengeStarsInfo,
    ChallengeParentGoalModal,
  },
  props: {
    currentChild: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    ...mapGetters('challenge', ['getPossibleStarsToday', 'homeChallengeSkillId', 'getStarsEarned']),
    starsEarnedByChild() {
      return this.getStarsEarned;
    },
  },
  methods: {
    openModal() {
      this.$refs.newModal.openModal();
    },
  },
};
</script>
<style lang="scss">
.parent-controls {
  .challenge-buttons-groups {
    gap: 1rem;
    flex-grow: 1;
    @media (max-width: 575px) {
      width: 100%;
    }
  }
}
</style>
